import { Flex, Text } from '@chakra-ui/react';
import { PauseCircle } from '@time-line/components/icons';
import { SUBSCRIPTION_CANCELLATION_NOTE } from 'lib/constants/products';

export const ProductConfiguratorCancellationNote = () => (
  <Flex alignItems="center" gap="3xs">
    <PauseCircle boxSize="xs" />
    <Text size="detail">{SUBSCRIPTION_CANCELLATION_NOTE}</Text>
  </Flex>
);
